import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-duna-faq',
  standalone: true,
  imports: [],
  templateUrl: './duna-faq.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./duna-faq.component.scss'],
})
export class DunaFaqComponent {
  faqData = [
    {
      question: 'Hvad står DUNA for?',
      answer:
        'DUNA står for Digital Uddannelsesadministration. Det er en platform skabt specifikt for brandfolk og redningspersonale i Danmark til at administrere kurser, øvelser og uddannelser.',
    },
    {
      question: 'Hvem har udviklet DUNA?',
      answer:
        'DUNA er udviklet af Rastec ApS, en dansk virksomhed med erfaring og ekspertise indenfor digitalisering og infrastruktur.',
    },
    {
      question: 'Hvordan logger jeg ind på DUNA?',
      answer:
        "Du kan logge ind via din organisations's C3 eller bruge den eksterne login-side hvis du har fået tildelt adgang som ekstern bruger.",
    },
    {
      question: 'Kan jeg tilmelde mig kurser gennem DUNA?',
      answer:
        'Ja, DUNA gør det nemt at browse og tilmelde dig til kurser, øvelser og uddannelser. Du får også automatiske påmindelser og kan følge dit fremskridt.',
    },
    {
      question: 'Hvad hvis jeg har tekniske problemer?',
      answer:
        'Hvis du oplever tekniske problemer, kan du kontakte support gennem kontaktformularen eller din lokale IT-koordinator på brandstationen.',
    },
  ];

  private openItems: number[] = [];

  toggleItem(index: number) {
    const currentIndex = this.openItems.indexOf(index);
    if (currentIndex > -1) {
      this.openItems.splice(currentIndex, 1);
    } else {
      this.openItems.push(index);
    }
  }

  isOpen(index: number): boolean {
    return this.openItems.includes(index);
  }
}
